import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { AccountServiceProvider } from '../../providers/account-service/account-service';
import { Shareddata } from '../../providers/shareddata';
import { FuncsService } from '../../services/funcs.services';
import Masonry from 'masonry-layout';
import * as imagesLoaded from 'src/assets/js/imagesloaded.pkgd.min.js';
import smoothscroll from 'smoothscroll-polyfill';

@Component({
	selector      : 'app-team',
	templateUrl   : './team.component.html',
	encapsulation : ViewEncapsulation.None
})

export class TeamComponent implements OnInit {
	@Input() teamData : any;
	public team_participant_data : any = [];
	public new_team              : any = [];
	public team_contact_info     : any;
	public action                : any = 'listing';
	public loadMoreButton   : boolean = true;
	public showMoreButton   : boolean = true;
	public show_detail_page : boolean = false;

	constructor(
		private accountService : AccountServiceProvider,
		public shareddata      : Shareddata,
		private funcs          : FuncsService,
	) {
		smoothscroll.polyfill();
		this.funcs.globalLocalStorageHttp();
		var userData = this.funcs.globalSetUserSession();
		if ( userData )
			this.shareddata.setUserSession( userData );
		let params = {
			'offset' : 0,
		};
		this.accountService.getTeamInfo().then( ( response: any ) => {
			if ( 'Ok' === response.status ) {
				this.team_contact_info = response.team_info;
				this.new_team = response.team_list;
				let myObj = {
					offset : params.offset,
					limit  : 20,
				}
				sessionStorage.setItem( 'teams', JSON.stringify( myObj ) );
				if ( this.new_team.length >= 20 )
					this.showMoreButton = true;
				else
					this.showMoreButton = false;
				this.loadMoreButton = false;
				setTimeout (
				() => {
					this.ngAfterViewInit();
					}, 300
				);
			}
		})
	}

	ngOnInit() {}

	ngAfterViewInit() {
		setTimeout (
			() => {
				if ( document.querySelector( '.team-grid' ) ) {
					var teamElem = document.querySelector( '.team-grid' );
					var teamElemmsnry = new Masonry( teamElem, {
						itemSelector: '.team-grid-item',
						columnWidth: '.grid-sizer-3',
						horizontalOrder: true,
						percentPosition: true,
					});

					imagesLoaded( teamElem ).on( 'progress', function() {
						teamElemmsnry.layout();
					});
				}
			}, 500
		);
	}

	loadMoreTeam() {
		this.loadMoreButton = true;
		this.showMoreButton = false;
		let localTeamSessionItems = JSON.parse( sessionStorage.getItem( 'teams' ) );
		let next_offset   = parseInt( localTeamSessionItems.offset ) + parseInt( localTeamSessionItems.limit );
		let params = {
			'offset' : next_offset,
			'limit'  : localTeamSessionItems.limit,
		};
		localTeamSessionItems.offset = next_offset;
		sessionStorage.setItem( 'teams', JSON.stringify( localTeamSessionItems ) );
		this.accountService.getWpTeamParticipants( params ).then( ( response: any ) => {
			if ( response.status == 'Ok' ) {
				if ( response.data != '' && response.data != null ) {
					for ( let value in response.data )
						this.new_team.push( response.data[ value ] );
					if ( response.data.length >= localTeamSessionItems.limit )
						this.showMoreButton = true;
					else
						this.showMoreButton = false;
				} else {
					this.showMoreButton = false;
				}
				// this.ngAfterViewInit();
			}
			this.loadMoreButton = false;			
		});
	}
}
